import React from "react";

const check = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C14.7848 2 17.4555 3.10625 19.4246 5.07538C21.3938 7.04451 22.5 9.71523 22.5 12.5C22.5 15.2848 21.3938 17.9555 19.4246 19.9246C17.4555 21.8938 14.7848 23 12 23C9.21523 23 6.54451 21.8938 4.57538 19.9246C2.60625 17.9555 1.5 15.2848 1.5 12.5C1.5 9.71523 2.60625 7.04451 4.57538 5.07538C6.54451 3.10625 9.21523 2 12 2ZM10.692 14.5715L8.3595 12.2375C8.27588 12.1539 8.17661 12.0876 8.06736 12.0423C7.9581 11.997 7.84101 11.9737 7.72275 11.9737C7.60449 11.9737 7.4874 11.997 7.37814 12.0423C7.26889 12.0876 7.16962 12.1539 7.086 12.2375C6.91712 12.4064 6.82225 12.6354 6.82225 12.8743C6.82225 13.1131 6.91712 13.3421 7.086 13.511L10.056 16.481C10.1394 16.565 10.2386 16.6317 10.3479 16.6773C10.4571 16.7228 10.5744 16.7462 10.6927 16.7462C10.8111 16.7462 10.9284 16.7228 11.0376 16.6773C11.1469 16.6317 11.2461 16.565 11.3295 16.481L17.4795 10.3295C17.5642 10.2462 17.6316 10.147 17.6778 10.0375C17.724 9.92809 17.7481 9.81057 17.7487 9.69177C17.7492 9.57297 17.7262 9.45523 17.6811 9.34535C17.6359 9.23547 17.5694 9.13562 17.4854 9.05156C17.4015 8.96751 17.3017 8.9009 17.1919 8.8556C17.0821 8.81029 16.9644 8.78718 16.8455 8.78759C16.7267 8.788 16.6092 8.81193 16.4997 8.858C16.3902 8.90407 16.2909 8.97136 16.2075 9.056L10.692 14.5715Z"
        fill="#07802A"
      />
    </svg>
  );
};

export default check;
